export type BillingDialog = 'upgrade' | 'credits';

export const readBillingDialog = (search: string): BillingDialog | null => {
  const value = new URLSearchParams(search).get('dialog');
  return value === 'upgrade' || value === 'credits' ? value : null;
};

export const setBillingDialog = (
  search: string,
  dialog: BillingDialog | null
): string => {
  const params = new URLSearchParams(search);
  if (dialog) params.set('dialog', dialog);
  else params.delete('dialog');
  const next = params.toString();
  return next ? `?${next}` : '';
};
